import React from 'react'
import { useNavigate } from '@remix-run/react'
import { CirclePlus, Trash, Plus } from 'lucide-react'
import { Button , DotIndicator } from "@fr8/frui"
import type { UseFieldArrayRemove } from 'react-hook-form'
import IndentEmptySvg from '~/components/assets/svg/indentEmptySvg'
import { Icity } from '../type'
import { constants } from '~/utils/constants'

export function Errors(props: { error?: string, note?: string }) {
  if (!props.error) return null
  return <p className="mt-1! text-destructive">{props?.note?props?.note+' - ':""}{props.error}</p>
}

interface IcityItems {
  cities: Icity[]
  error?: string
  remove: UseFieldArrayRemove
  navigateTo?: ()=>void
  type?: 'S'
  placeholder: string
  sourceLength?: number
}

export const CityItems = (props: IcityItems) => {
  const { cities, error, remove, navigateTo, type, placeholder, sourceLength } = props
  return (
    <>
      {cities?.length > 0 ? (
        cities.map((city: Icity, index: number) => {
          return (
            <CityItem
              key={`${city.city_id}${index}`}
              type={type}
              index={sourceLength ? sourceLength + index : index}
              error={error}>
              <ItemDetail
                city={city}
                navigateTo={navigateTo}
                remove={remove}
                index={index}
                type={type}
              />
            </CityItem>
          )
        })
      ) : (
        <CityItem
          type={type}
          index={!type ? sourceLength || 1 : 0}
          navigateTo={navigateTo}
          error={error}>
          <p className="py-2 text-muted-foreground">{placeholder}</p>
        </CityItem>
      )}
    </>
  )
}
interface IcityItem {
  children: React.ReactNode
  type?: 'S' | 'D'
  index: number
  error?: string
  navigateTo?: () => void
}
const CityItem = (props: IcityItem) => {
  const { children, type, index, error, navigateTo } = props

  return (
    <div>
      <div className="relative z-10 my-2 flex items-center justify-center gap-2 shrink-0">
        <DotIndicator variant={type === 'S' ? 'loading' : 'unloading'} text={'present'} className='shrink-0'>
          {index + 1}
        </DotIndicator>
        <div
          role={navigateTo ? 'button' : undefined}
          tabIndex={navigateTo ? 0 : undefined}
          onClick={navigateTo || undefined}
          onKeyDown={
            navigateTo
              ? (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    navigateTo()
                  }
                }
              : undefined
          }
          className={`w-full min-w-0 rounded-md border border-input p-1 pl-3 ${navigateTo ? 'cursor-pointer' : ''}`}>
          {children}
        </div>
      </div>
      {error ? (
        <div className="ml-6">
          <Errors error={error} />
        </div>
      ) : null}
    </div>
  )
}
interface IitemDetail {
  city: Icity
  index: number
  remove: UseFieldArrayRemove
  navigateTo?: ()=>void
  type?: 'S' | 'D'
}
const ItemDetail = (props: IitemDetail) => {
  const { city, index, remove, navigateTo } = props
  
  const handleRemove = () => {
    remove(index)
  }

  return (
    <div className="flex items-center justify-between">
      <div className="flex-1 shrink-0 min-w-0">
        <h4 className="truncate whitespace-nowrap">
          {city.city_name}
          <span >, {city.country_name}</span>
        </h4>
      </div>
      <div className="flex flex-row-reverse">
        <Button
          type="button"
          variant={'ghost'}
          ghostVariant={'secondary'}
          size={'icon'}
          onClick={navigateTo || undefined}>
          <CirclePlus size={16} />
        </Button>
        <Button type="button" variant={'ghost'} ghostVariant={'destructive'} size={'icon'} onClick={handleRemove}>
          <Trash size={16} />
        </Button>
      </div>
    </div>
  )
}

export const IndentEmpty = () => {
  const navigate = useNavigate()
  // Todo url from constants
   const createIndent = () => {
    const params = new URLSearchParams(window.location.search);
    const s_id = params.get('s_id');
    const s_n  = params.get('s_n');
    const d_id = params.get('d_id');
    const d_n  = params.get('d_n');

    const state = (s_id && s_n && d_id && d_n)
      ? {
          source: { city_id: s_id, city_name: s_n },
          destination: { city_id: d_id, city_name: d_n },
        }
      : undefined;

    navigate(constants.shipper.createIndent, { replace: true, state });
  }

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center space-y-5">
      <IndentEmptySvg />
      <p className="text-muted-foreground/70">Create load & get best matching trucks</p>
      <Button
        className="bg-card shadow-md"
        variant={'ghost'}
        ghostVariant={'secondary'}
        onClick={createIndent}>
        <Plus size={18} /> Add new load
      </Button>
    </div>
  )
}
